import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Package } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { formatCurrency } from '@/utils/currency';

const ProductCard = ({ product }) => {
  const hasDiscount = product.discount_percentage && product.discount_percentage > 0;
  const finalPrice = hasDiscount 
    ? product.price * (1 - product.discount_percentage / 100)
    : product.price;
  
  return (
    <div className="product-card glass rounded-2xl overflow-hidden fade-in" data-testid="product-card">
      <Link to={`/product/${product.id}`}>
        <div className="relative overflow-hidden group">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
            data-testid="product-card-image"
          />
          <div className="absolute top-4 right-4 flex flex-col gap-2">
            {hasDiscount && (
              <div className="bg-red-600 text-white px-3 py-1 rounded-full text-sm font-bold animate-pulse" data-testid="discount-badge">
                -{product.discount_percentage}%
              </div>
            )}
            {product.featured && (
              <div className="bg-purple-600 text-white px-3 py-1 rounded-full text-sm font-bold">
                Destacado
              </div>
            )}
          </div>
          {product.stock === 0 && (
            <div className="absolute inset-0 bg-black/70 flex items-center justify-center">
              <span className="text-white text-xl font-bold">Sin Stock</span>
            </div>
          )}
        </div>
      </Link>

      <div className="p-6">
        <div className="text-purple-400 text-sm mb-2" data-testid="product-card-category">{product.category}</div>
        <Link to={`/product/${product.id}`}>
          <h3 className="text-xl font-bold text-white mb-2 hover:text-purple-400 transition-colors" data-testid="product-card-name">
            {product.name}
          </h3>
        </Link>
        <p className="text-gray-400 text-sm mb-4 line-clamp-2" data-testid="product-card-description">{product.description}</p>
        
        <div className="flex items-center justify-between">
          <div data-testid="product-card-price">
            {hasDiscount ? (
              <div className="flex flex-col">
                <span className="text-gray-500 line-through text-sm">{formatCurrency(product.price)}</span>
                <span className="text-2xl font-bold text-purple-400">{formatCurrency(finalPrice)}</span>
              </div>
            ) : (
              <div className="text-2xl font-bold text-purple-400">
                {formatCurrency(product.price)}
              </div>
            )}
          </div>
          <div className="flex items-center gap-2 text-gray-400 text-sm">
            <Package size={16} />
            <span data-testid="product-card-stock">{product.stock}</span>
          </div>
        </div>

        {hasDiscount && (
          <div className="mt-2 text-green-400 text-sm font-bold">
            ¡Ahorra {formatCurrency(product.price - finalPrice)}!
          </div>
        )}

        <Link to={`/product/${product.id}`}>
          <Button 
            className="w-full mt-4 btn-primary bg-purple-600 hover:bg-purple-700 text-white rounded-full"
            data-testid="view-details-button"
          >
            Ver Detalles
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default ProductCard;